// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var ListCampaignsRequest_SortField;
(function (ListCampaignsRequest_SortField) {
    ListCampaignsRequest_SortField["START_SEND_AT"] = "START_SEND_AT";
    ListCampaignsRequest_SortField["CREATED_AT"] = "CREATED_AT";
})(ListCampaignsRequest_SortField || (ListCampaignsRequest_SortField = {}));
export var ListCampaignsRequest_SortField_index;
(function (ListCampaignsRequest_SortField_index) {
    ListCampaignsRequest_SortField_index[ListCampaignsRequest_SortField_index["START_SEND_AT"] = 0] = "START_SEND_AT";
    ListCampaignsRequest_SortField_index[ListCampaignsRequest_SortField_index["CREATED_AT"] = 1] = "CREATED_AT";
})(ListCampaignsRequest_SortField_index || (ListCampaignsRequest_SortField_index = {}));
export var ListRecipientsRequest_StatusFilter;
(function (ListRecipientsRequest_StatusFilter) {
    ListRecipientsRequest_StatusFilter["ALL_STATUSES"] = "ALL_STATUSES";
    ListRecipientsRequest_StatusFilter["DELIVERED"] = "DELIVERED";
    ListRecipientsRequest_StatusFilter["FAILED"] = "FAILED";
})(ListRecipientsRequest_StatusFilter || (ListRecipientsRequest_StatusFilter = {}));
export var ListRecipientsRequest_StatusFilter_index;
(function (ListRecipientsRequest_StatusFilter_index) {
    ListRecipientsRequest_StatusFilter_index[ListRecipientsRequest_StatusFilter_index["ALL_STATUSES"] = 0] = "ALL_STATUSES";
    ListRecipientsRequest_StatusFilter_index[ListRecipientsRequest_StatusFilter_index["DELIVERED"] = 1] = "DELIVERED";
    ListRecipientsRequest_StatusFilter_index[ListRecipientsRequest_StatusFilter_index["FAILED"] = 2] = "FAILED";
})(ListRecipientsRequest_StatusFilter_index || (ListRecipientsRequest_StatusFilter_index = {}));
export var ListRecipientsRequest_EngagementFilter;
(function (ListRecipientsRequest_EngagementFilter) {
    ListRecipientsRequest_EngagementFilter["ALL_ENGAGEMENT_TYPES"] = "ALL_ENGAGEMENT_TYPES";
    ListRecipientsRequest_EngagementFilter["POSITIVE"] = "POSITIVE";
    ListRecipientsRequest_EngagementFilter["NEGATIVE"] = "NEGATIVE";
    ListRecipientsRequest_EngagementFilter["NEUTRAL"] = "NEUTRAL";
})(ListRecipientsRequest_EngagementFilter || (ListRecipientsRequest_EngagementFilter = {}));
export var ListRecipientsRequest_EngagementFilter_index;
(function (ListRecipientsRequest_EngagementFilter_index) {
    ListRecipientsRequest_EngagementFilter_index[ListRecipientsRequest_EngagementFilter_index["ALL_ENGAGEMENT_TYPES"] = 0] = "ALL_ENGAGEMENT_TYPES";
    ListRecipientsRequest_EngagementFilter_index[ListRecipientsRequest_EngagementFilter_index["POSITIVE"] = 1] = "POSITIVE";
    ListRecipientsRequest_EngagementFilter_index[ListRecipientsRequest_EngagementFilter_index["NEGATIVE"] = 2] = "NEGATIVE";
    ListRecipientsRequest_EngagementFilter_index[ListRecipientsRequest_EngagementFilter_index["NEUTRAL"] = 3] = "NEUTRAL";
})(ListRecipientsRequest_EngagementFilter_index || (ListRecipientsRequest_EngagementFilter_index = {}));
export const Bulk = {
    // ------------------------------------------------------------
    // -------------------- campaign endpoints --------------------
    // ------------------------------------------------------------
    // GetCampaignsSummary returns a summary of campaigns for the requested year. The summary includes the requested number of campaigns per month.
    // When getting the summary, campaigns will not have template_json or message_template fields populated.
    GetCampaignsSummary(fn, req) {
        return fn(`/messaging/bulk/v2/summary?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ListCampaigns lists campaigns according to the provided filters.  When listing campaigns, campaigns will not have template_json or message_template fields populated.
    ListCampaigns(fn, req) {
        return fn(`/messaging/bulk/v2/campaigns?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // CreateCampaign creates a new campaign with the provided parameters. When creating a campaign, the status must be set to DRAFT or HIDDEN_DRAFT.
    CreateCampaign(fn, req) {
        return fn(`/messaging/bulk/v2/campaigns`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UpdateCampaign updates an existing campaign with the provided parameters.
    UpdateCampaign(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["campaign"]) === null || _a === void 0 ? void 0 : _a["campaignId"], "campaign.campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${(_b = req["campaign"]) === null || _b === void 0 ? void 0 : _b["campaignId"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteCampaign deletes a campaign
    DeleteCampaign(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "DELETE" });
    },
    // GetCampaign returns a single campaign.
    GetCampaign(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // ------------------------------------------------------------
    // ------------------------ recipients ------------------------
    // ------------------------------------------------------------
    ListRecipients(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/recipients?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // ------------------------------------------------------------
    // -------------------- audience endpoints --------------------
    // ------------------------------------------------------------
    // GetAudience returns the audience for the requested campaign. An audience is a view of recipients across all segments added for a campaign
    GetAudience(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/audience?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // LimitAudience applies the provided limits to the audience for the requested campaign
    LimitAudience(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/audience:limit`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ------------------------------------------------------------
    // -------------------- segments endpoints --------------------
    // ------------------------------------------------------------
    // ListSegments returns the segments for the requested campaign
    ListSegments(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/segments?${fm.renderURLSearchParams(req, ["campaignId"])}`, { method: "GET" });
    },
    // CreateSegment creates a new segment using the provided filter
    CreateSegment(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/segments`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteSegment deletes a segment and the associated recipients
    DeleteSegment(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
            fm.validateUrlParam(req["segmentId"], "segmentId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/segments/${req["segmentId"]}?${fm.renderURLSearchParams(req, ["campaignId", "segmentId"])}`, { method: "DELETE" });
    },
    // CountSegmentRecipients will return the number of recipients that the segment would contain if created
    CountSegmentRecipients(fn, req) {
        try {
            fm.validateUrlParam(req["campaignId"], "campaignId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/campaigns/${req["campaignId"]}/segments:countRecipients`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // ------------------------------------------------------------
    // --------------------- lists endpoints ----------------------
    // ------------------------------------------------------------
    ListLists(fn, req) {
        return fn(`/messaging/bulk/v2/lists?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateList(fn, req) {
        return fn(`/messaging/bulk/v2/lists`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/lists/${req["listId"]}?${fm.renderURLSearchParams(req, ["listId"])}`, { method: "GET" });
    },
    UpdateList(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["list"]) === null || _a === void 0 ? void 0 : _a["listId"], "list.listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/lists/${(_b = req["list"]) === null || _b === void 0 ? void 0 : _b["listId"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/v2/lists/${req["listId"]}?${fm.renderURLSearchParams(req, ["listId"])}`, { method: "DELETE" });
    },
    // ------------------------------------------------------------
    // ----------------------- miscellaneous ----------------------
    // ------------------------------------------------------------
    // ListActiveYears returns the years that have campaigns
    ListActiveYears(fn, req) {
        return fn(`/messaging/bulk/v2/active-years?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetUsage returns the usage for the requested year
    GetUsage(fn, req) {
        return fn(`/messaging/bulk/v2/usage?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // SendTestMessage sends a test message using the provided parameters to the provided destination
    SendTestMessage(fn, req) {
        return fn(`/messaging/bulk/v2/rpc:sendTestMessage`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
